/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { Oas30Example } from '../../openapi/v3/models/Oas30Example';
import { Oas30Parameter } from '../../openapi/v3/models/Oas30Parameter';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { IExample } from '../../core/models/common/IExample';

/**
 * A command used to delete all examples from a parameter.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllParameterExamplesCommand extends AbstractCommand {
    public _parameterPath : NodePath;

    public _oldExamples : any;

    public constructor(parameter? : any) {
        if(((parameter != null && parameter instanceof <any>Oas30Parameter) || parameter === null)) {
            let __args = arguments;
            super();
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            (() => {
                this._parameterPath = Library.createNodePath(parameter);
            })();
        } else if(parameter === undefined) {
            let __args = arguments;
            super();
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllParameterExamplesCommand] Executing.");
        if(this.isNullOrUndefined(document)) {
            LoggerCompat.debug("[DeleteAllParameterExamplesCommand] Could not execute the command, invalid argument.");
            return;
        }
        if(this.isNullOrUndefined(this._parameterPath)) {
            LoggerCompat.debug("[DeleteAllParameterExamplesCommand] Could not execute the command, problem when unmarshalling.");
            return;
        }
        let parameter : Oas30Parameter = <Oas30Parameter>this._parameterPath.resolve(document);
        if(this.isNullOrUndefined(parameter)) {
            LoggerCompat.debug("[DeleteAllParameterExamplesCommand] Parameter not found.");
            return;
        }
        this._oldExamples = <any>({});
        parameter.getExamples().forEach((e) => {
            /* put */(this._oldExamples[e.getName()] = Library.writeNode(<Node><any>e));
        });
        parameter.clearExamples();
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        if(this.isNullOrUndefined(document)) {
            LoggerCompat.debug("[DeleteAllParameterExamplesCommand] Could not revert the command, invalid argument.");
            return;
        }
        if(this.isNullOrUndefined(this._parameterPath)) {
            LoggerCompat.debug("[DeleteAllParameterExamplesCommand] Could not revert the command, problem when unmarshalling.");
            return;
        }
        LoggerCompat.info("[DeleteAllParameterExamplesCommand] Reverting.");
        let parameter : Oas30Parameter = <Oas30Parameter>this._parameterPath.resolve(document);
        if(this.isNullOrUndefined(parameter)) {
            LoggerCompat.info("[DeleteAllParameterExamplesCommand] No parameter found.");
            return;
        }
        if(this.isNullOrUndefined(this._oldExamples)) {
            LoggerCompat.info("[DeleteAllExamplesCommand] Could not revert. Previous data is not available.");
            return;
        }
        {
            let array142 = /* keySet */Object.keys(this._oldExamples);
            for(let index141=0; index141 < array142.length; index141++) {
                let k = array142[index141];
                {
                    let example : Oas30Example = parameter.createExample(k);
                    Library.readNode(/* get */((m,k) => m[k]===undefined?null:m[k])(this._oldExamples, k), example);
                    parameter.addExample(example);
                }
            }
        }
    }
}
DeleteAllParameterExamplesCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllParameterExamplesCommand";
DeleteAllParameterExamplesCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




